import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectNotFoundUrl } from '../../selectors/notFoundUrl';
import { EmptyPage } from '../../components/EmptyPage';
import { trackNavigationToFlats, trackNavigationToJK } from './tracking';
import { selectComparePageType, selectIsDesktop } from '../../selectors/page';

export const EmptyPageContainer: React.FC<{}> = () => {
  const notFoundUrl = useSelector(selectNotFoundUrl);
  const pageType = useSelector(selectComparePageType);
  const isDesktop = useSelector(selectIsDesktop);

  const handleClick = React.useCallback(() => {
    const siteType = isDesktop ? 'desktop' : 'mobile';

    if (pageType === 'newbuildings') {
      trackNavigationToJK(siteType);
    } else {
      trackNavigationToFlats(siteType);
    }
  }, [isDesktop, pageType]);

  return (
    <EmptyPage isMobile={!isDesktop} notFoundUrl={notFoundUrl} onNotFoundUrlClick={handleClick} pageType={pageType} />
  );
};
